<div>
  <h1 mat-dialog-title>{{data.title}}</h1>
  <div mat-dialog-content>
    <p>{{data.message}}</p>
  </div>
  @if (!noButtons) {
    <div mat-dialog-actions>
      <!-- <button mat-button (click)="onNoClick()">No Thanks</button> -->
      <button mat-button class="btn-close" [mat-dialog-close]="data.title"
      cdkFocusInitial>{{cancelButtonText}}</button>
    </div>
  }
</div>